<template>
  <div class="position-header">
    <navHeader :titleList="['交换名称', '交换名片详情']" />
    <div class="rhBrand-content common-padding" v-loading="loading">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form ref="form" class="add-form" :model="form" label-width="400px">
              <el-form-item label="展商名称：">
                <el-input v-model="form.companyName" disabled></el-input>
              </el-form-item>
              <el-form-item label="观众姓名：">
                <el-input v-model="form.translateName" disabled></el-input>
              </el-form-item>
              <el-form-item label="观众公司名：">
                <el-input v-model="form.translateCompanyName" disabled></el-input>
              </el-form-item>
              <el-form-item label="观众邮箱：">
                <el-input v-model="form.translateEmail" disabled></el-input>
              </el-form-item>
              <el-form-item label="观众职务：">
                <el-input v-model="form.translatePosition" disabled></el-input>
              </el-form-item>
              <el-form-item label="观众手机号：">
                <el-input v-model="form.phone" disabled></el-input>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button @click="back">返 回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      loading: false,
      form: {
        companyName: '',
        translateName: '',
        translateCompanyName: '',
        translateEmail: '',
        translatePosition: '',
        phone: ''
      }
    }
  },
  components: {
    navHeader
  },
  created () {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id)
    } else {
      this.loading = false
    }
  },
  methods: {
    async getData (id) {
      this.loading = true
      this.$http.post('/exchangeCards/exchangeCards/getById', {id}).then(res => {
        if (res.data.code === '200') this.form = res.data.data
      }).finally(() => {
        this.loading = false
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/exchangeCards/detail.vue